import {FC} from "react";
import {useSelector} from "react-redux";

import styles from "../headerBtn.module.scss";

const ConsolidatedBudgetExportSection: FC = () => {
    const {selectedProjectsId, projectsById} = useSelector((state: any) => state.consolidatedbudget.projects);

    return (
        <div className={styles.block__info}>
      <span>
        {!selectedProjectsId?.length && "Все доступные проекты"}
      </span>
            {!!selectedProjectsId?.length && (
                <div className={styles.consolidated__budget_block}>
                    <span>{"Выбранные проекты: " + selectedProjectsId?.length}</span>
                    <div className={styles.consolidated__budget_list}>
                        {selectedProjectsId?.map((project: { id: number }) => (projectsById[project.id]))
                            .sort((a: string, b: string) => (a > b ? 1 : -1))
                            .map((project: string, index: number) => (
                                <p key={index} className={styles.consolidated__budget}>
                                    {project}
                                </p>
                            ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConsolidatedBudgetExportSection;
